import React, { createContext, useContext, ReactNode } from 'react';
import { useCalculatorForm } from '../hooks/useCalculatorForm';
import { FormState, CalculationResult, ClipboardState } from '../types';

// Define the context type
interface CalculatorContextType {
  formState: FormState;
  setFormState: React.Dispatch<React.SetStateAction<FormState>>;
  result: CalculationResult | null;
  showStdDev: boolean;
  clipboardState: ClipboardState;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  toggleLogTransformation: () => void;
  copySamplesPerVariant: () => Promise<void>;
  copyTotalSampleSize: () => Promise<void>;
  copyShareUrl: () => Promise<void>;
}

// Create the context with a default undefined value
const CalculatorContext = createContext<CalculatorContextType | undefined>(undefined);

// Provider component
export const CalculatorProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const calculatorState = useCalculatorForm();
  
  return (
    <CalculatorContext.Provider value={calculatorState}>
      {children}
    </CalculatorContext.Provider>
  );
};

// Custom hook to use the calculator context
export const useCalculator = (): CalculatorContextType => {
  const context = useContext(CalculatorContext);
  
  if (context === undefined) {
    throw new Error('useCalculator must be used within a CalculatorProvider');
  }
  
  return context;
};
